angular.module('cpm').constant('CONTENT_TYPE', {
    FEED: 'feed',
    CAMPAIGN: 'campaign',
    ACCOUNT: 'account',
    CLIENT: 'client',
    CREATIVE: 'creative',
    ADVERTISER: 'advertiser',
    ASSET: 'asset',
    TEMPLATE: 'template',
    USER: 'auth',
    CLIENTADMIN: 'admin',
    FOLDER: 'folder'
});
